<template>
  <main class="home row iso">
    <article class="iso-content columns is-desktop is-centered">
      <img
        src="../assets/images/banners/soporte_interno_mobile.svg"
        class="banner-iso column inverse"
        alt=""
      />
      <section class="column content is-half-desktop">
        <h2 class="title">POLÍTICA DE SEGURIDAD DE LA INFORMACIÓN</h2>
        <h3>CONTAFÁCIL</h3>
        <h4>ISO27001:2103</h4>
        <p>
          El manejo de la confidenciabilidad, integridad y disopnibilidad de la
          información por parte de todo el personal, es un hábito vital dentro
          de la cultura organizacional de la empresa.
        </p>
        <p>
          Practicamos constantemente el análisis y evaluación de riesgos, que
          nos permite contar con una infraestructura tecnológica, segura y
          controlada, ayudandonos a otorgar servicios óptimos y de calidad para
          ser una solución confiable a nuestros clientes.
        </p>
        <p>
          Estamos comprometidos con la mejora continua y con el cumplimiento de
          aspectos regulatorios, contractuales y reglamentarios.
        </p>

        <h2>
          ALCANCE DEL SISTEMA DE GESTIÓN DE SEGURIDAD DE LA INFORMACIÓN
          CONTAFÁCIL
        </h2>
        <p>
          Sistema de Gestión de Seguridad de Información para el proceso de
          facturación electrónica en conformidad con el ISO 27001:2013, en
          concordancia con la declaración de Aplicabilidad, Versión PO01002
        </p>
        <p>
          Las interfases son las siguientes: Desarrollo de SW, Soporte, Legal,
          Comercial, Gerencia de TI, Gerencia General, Gerencia de Operaciones.
          Las dependencias son: SUNAT, OSE, Ckientes, Proveeedores.
        </p>
      </section>
      <img
        src="../assets/images/banners/soporte_interno_mobile.svg"
        class="banner-iso column"
        alt=""
      />
    </article>
  </main>
</template>

<script>
export default {
  name: "Iso"
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/general";
.iso {
  padding: 3rem;
  &-content {
    align-items: flex-start;
    .content {
      margin: 1rem auto;
      h2,
      h3,
      h4 {
        font-size: 1.3rem;
        line-height: 1.2;
        letter-spacing: 0.05em;
        font-family: "Quicksand", Avenir, Arial, Helvetica, sans-serif;
        font-weight: bold;
        &.title {
          margin-bottom: 0;
        }
        @include tablet() {
          font-size: 1.2rem;
        }
        @include laptop() {
          font-size: 1.2rem;
        }
        @include desktop() {
          font-size: 1.2rem;
        }
      }
      h3,
      h4 {
        margin: 0 auto;
      }
      p {
        margin: 1.2rem auto;
        font-size: 1.1rem;
        line-height: 1.2;
        @include tablet() {
          font-size: 1.1rem;
        }
        @include laptop() {
          font-size: 1.1rem;
        }
        @include desktop() {
          font-size: 1.2rem;
        }
      }
    }
    .banner-iso {
      margin: 0 auto;
      flex-shrink: 1;
      padding: 0;
      &.inverse {
        transform: rotateY(180deg);
      }
    }
  }
}
</style>
